import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {
  clearSupabaseAccessTokenProvider,
  setSupabaseAccessTokenProvider,
} from '../supabaseClient';
import { createSupabaseTokenProvider } from './supabaseTokenProvider';

const SupabaseAuthBridge = () => {
  const {
    isAuthenticated,
    isLoading,
    getIdTokenClaims,
    getAccessTokenSilently,
  } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) {
      clearSupabaseAccessTokenProvider();
      return () => {
        clearSupabaseAccessTokenProvider();
      };
    }

    setSupabaseAccessTokenProvider(
      createSupabaseTokenProvider({
        isAuthenticated,
        isLoading,
        getIdTokenClaims,
        getAccessTokenSilently,
      })
    );

    return () => {
      clearSupabaseAccessTokenProvider();
    };
  }, [getAccessTokenSilently, getIdTokenClaims, isAuthenticated, isLoading]);

  return null;
};

export default SupabaseAuthBridge;
